import * as Yup from 'yup';

export const driverLicense = Yup.string()
  .trim()
  .max(50, 'Driver License should be less than 50 symbols')
  .required('Driver License is required');
